export class AssetMigrationStatements {
  migrations = [
    `CREATE TABLE IF NOT EXISTS asset
     (
         id                       TEXT PRIMARY KEY,
         dataType                 TEXT,
         json                     TEXT,
         assetState               TEXT,
         farmId                   TEXT
     );`
  ]
}
